import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import {V1ObjectAuditHistoryIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";

// Audit rows behind an object's History tab (t1/v1/object_audit_histories).
//
// Read-only by design: rows are written by the backend's PostWriteRecordAuditEvent hooks and the
// endpoint exposes GET only, so no performInsert/Update/Delete is implemented here. The base class's
// versions would issue calls the API rejects, which is a clearer failure than silently pretending.
const IDOC = "v1.ObjectAuditHistory-001";
const URL = "t1/v1/object_audit_histories";

class ObjectAuditHistoryEnterpriseComponent extends EnterpriseComponent {

    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? IDOC;

        let members = [];
        let queryPayload = this.prepareQueryPayload();
        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;
                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) operator = queryPayload.get(key + "_query");
                members.push({"Type": "Attribute", "Name": key, "Value": value, "Operator": operator});
            }
        }

        let QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "ObjectAuditHistory": {
                    "_attributes": {"limit": pageSize, "sort": this.getFormattedSortSpecification(), "offset": (page - 1) * pageSize},
                    "QueryGroups": {"QueryGroup": [{"Name": "primary", "Operator": "AND", "Type": "QueryGroup", "Membership": {"Member": members}}]}
                }
            }
        };

        AxiosFoundationAPI({
            method: "GET",
            url: URL,
            json: true,
            params: {"QBE": btoa(JSON.stringify(QBE))},
            headers: {
                "visibility-mode": this.getVisibilityMode(),
                "visibility-value": this.getVisibilityValue(),
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ObjectAuditHistoryIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default ObjectAuditHistoryEnterpriseComponent;
